var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (user) {
jade_mixins["checkbox"] = jade_interp = function(name, disabled){
var block = (this && this.block), attributes = (this && this.attributes) || {};
buf.push("<div class=\"settings-split artsy-checkbox\"><div class=\"settings-split__left\"><label" + (jade.attr("for", name, true, true)) + " class=\"artsy-checkbox--label js-settings-checkbox-label\">");
block && block();
buf.push("</label></div><div class=\"settings-split__right\"><div class=\"artsy-checkbox--checkbox\"><input type=\"checkbox\"" + (jade.attr("id", name, true, true)) + (jade.attr("name", name, true, true)) + (jade.attr("checked", user && user.isChecked(name), true, true)) + (jade.attr("disabled", disabled, true, true)) + "><label" + (jade.attr("for", name, true, true)) + "></label></div></div></div>");
};
buf.push("<form class=\"stacked-form\"><div class=\"form-errors js-form-errors\"></div>");
jade_mixins["checkbox"].call({
block: function(){
buf.push("I understand that this will permanently delete my account and cannot be undone.");
}
}, 'confirm');
buf.push("<label for=\"explanation\" class=\"avant-garde-form-label\">Please Tell Us Why</label><textarea id=\"explanation\" name=\"explanation\" rows=\"5\" class=\"bordered-input\"></textarea><button disabled=\"disabled\" class=\"avant-garde-button-black\">Delete My Account</button></form>");}.call(this,"user" in locals_for_with?locals_for_with.user:typeof user!=="undefined"?user:undefined));;return buf.join("");
};
module.exports = template;